import { TokenUpgradeResponse } from '@msc-b2c/interfaces/interfaces';
import { LoginMode } from '@msc-b2c/interfaces/enums';

export const TokenUpgradeResponseMock: TokenUpgradeResponse = {
  token: 'eyJhbGciOiJIUzI1NiIsIn',
  loginMode: LoginMode.FULL,
  crmasisId: '1',
  goldenId: '1',
  passengerId: '1',
  bookingNumber: '32133243',
  name: 'Piero',
  surname: 'Zeno',
};
